export default "__VITE_ASSET__c56a84e2__"